/*
 * EditTeacher Messages
 *
 * This contains all the text for the EditTeacher component.
 */
import { defineMessages } from 'react-intl';

export default defineMessages({
    save: {
        id: 'app.components.EditTeacher.save',
        defaultMessage: 'Save'
    },
    cancel: {
        id: 'app.components.EditTeacher.cancel',
        defaultMessage: 'Cancel'
    },
    passwordValidationMessage1: {
        id: 'app.components.EditTeacher.passwordValidationMessage1',
        defaultMessage: 'New password does not meet stated rules'
    },
    passwordValidationMessage2: {
        id: 'app.components.EditTeacher.passwordValidationMessage2',
        defaultMessage: 'Ensure teacher passwords match'
    },
    passwordValidationMessage3: {
        id: 'app.components.EditTeacher.passwordValidationMessage3',
        defaultMessage: 'Please enter admin password'
    },
    passwordValidationMessage4: {
        id: 'app.components.EditTeacher.passwordValidationMessage4',
        defaultMessage: 'Password cannot be blank'
    },
    emailRequiredMessage: {
        id: 'app.components.EditTeacher.emailRequiredMessage',
        defaultMessage: 'Email is required'
    },
    emailValidationMessage: {
        id: 'app.components.EditTeacher.emailValidationMessage',
        defaultMessage: 'Invalid email'
    },
    teacherTitleNone: {
        id: 'app.components.EditTeacher.teachertTitle.none',
        defaultMessage: 'None'
    },
    teacherTitleNone_key: {
        id: 'app.components.EditTeacher.teachertTitle.none.key',
        defaultMessage: 'none'
    }
});



// WEBPACK FOOTER //
// ./app/components/edit-teacher-form/messages.js